import { Box, Grid, Paper, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import {
  Datagrid,
  DeleteButton,
  EditButton,
  ReferenceArrayField,
  ShowBase,
  ShowProps,
  SimpleShowLayout,
  TextField,
  Title,
  useShowContext,
  useTranslate,
} from 'react-admin';

export const CountryShow: FC<ShowProps> = () => {
  return (
    <ShowBase>
      <CountryShowView />
    </ShowBase>
  );
};

const CountryShowView = (props: any) => {
  const translate = useTranslate();
  const { title } = props;
  const { resource, defaultTitle } = useShowContext();
  return (
    <>
      <Title title={title} defaultTitle={defaultTitle} preferenceKey={`${resource}.show.title`} />
      <Stack>
        <Grid container flexDirection="row">
          <Grid container spacing={4} justifyContent="flex-end" sx={{ mt: 4 }}>
            <EditButton />
            <DeleteButton />
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Typography variant="h2" sx={{ mb: 2 }}>
                {translate('resources.countries.tabs.general')}
              </Typography>
              <Paper>
                <SimpleShowLayout>
                  <TextField source="name" />
                </SimpleShowLayout>
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h2" sx={{ mb: 2 }}>
                {translate('resources.countries.tabs.regions')}
              </Typography>
              <ReferenceArrayField reference="regions" source="region_ids">
                <Paper>
                  <Datagrid
                    bulkActionButtons={false}
                    empty={
                      <Box sx={{ p: 2 }}>
                        <Typography variant="body2">{translate('resources.regions.empty')}</Typography>
                      </Box>
                    }
                  >
                    <TextField source="name" />
                  </Datagrid>
                </Paper>
              </ReferenceArrayField>
            </Grid>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};
